import React from 'react'
import swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Button from 'material-ui/Button';
import HelpIcon from '../icons/Help'
import { withStyles } from 'material-ui/styles'

import HelpModal from '../modals/help'

const styles = theme => ({
    button: {}
})

const mySwal = withReactContent(swal)

const HelpButton = (props) => {
    const handleClick = (isNotFirstVisit = true) => {
        mySwal({
            html: <HelpModal onClick={() => mySwal.clickConfirm()} />,
            type: "info",
            showConfirmButton: false,
        })
    }

    return (
        <Button color="inherit"
            className={props.classes.button}
            onClick={handleClick}>
            帮助
        </Button>
    )
}

export default withStyles(styles)(HelpButton)


// WEBPACK FOOTER //
// ./src/components/buttons/help.js